import React from 'react';

export const DUPLICATE_VEHICLE_WARNING_CONTENT = (
  <span className="text-base text-red sm280:break-keep">
    * 해당 차량은 이미 등록된 차량입니다.
    <br className="sm280:hidden" />
    중복 차량의 경우, 임의로 삭제될 수 있습니다.
  </span>
);
